var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 29,
    r: 12,
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005269",
    d: "M3.235 27.637l4.272-4.272a1 1 0 0 0-1.414-1.415l-4.272 4.272a1 1 0 0 0 1.414 1.415zm8.885 7.178l4.562-4.892a1 1 0 1 0-1.463-1.364l-4.562 4.892a1 1 0 1 0 1.463 1.364zM2.677 35.83l10.3-10.3a1 1 0 0 0-1.415-1.414l-10.3 10.3a1 1 0 0 0 1.415 1.414zm13.306-15.99L.933 15.68c-.903-.249-.998-1.49-.145-1.875L30.784.29a.967.967 0 0 1 1.057.147c.506.113.921.607.761 1.229l-8.196 31.862c-.233.907-1.473 1.024-1.872.178l-6.55-13.865zm.054-2.06L27.634 3.901 4.135 14.491l11.902 3.288zM29.58 5.384L17.885 19.183l5.274 11.164L29.58 5.385z"
  })))));
};
export default SvgNotifications;